{
  "name": "rhogicsom-frontend",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:staging": "ng cache clean && ng build --configuration staging",
    "build:production": "ng cache clean && ng build --configuration production --aot",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:RHOGICSOM-FRONTEND": "node dist/RHOGICSOM-FRONTEND/server/server.mjs"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.1",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/platform-browser": "^20.3.0",
    "@angular/platform-server": "^20.3.0",
    "@angular/router": "^20.3.0",
    "@angular/ssr": "^20.3.6",
    "@ngrx/store": "^21.0.1",
    "@ngrx/store-devtools": "^21.0.1",
    "@sentry/angular": "^10.36.0",
    "@tailwindcss/postcss": "^4.1.18",
    "@tanstack/angular-query-experimental": "^5.90.24",
    "angular-svg-icon": "^19.1.1",
    "crypto-js": "^4.2.0",
    "dayjs": "^1.11.19",
    "express": "^5.1.0",
    "ng-zorro-antd": "20.4.4",
    "ngrx-store-localstorage": "^20.1.0",
    "ngx-scrollbar": "^19.1.4",
    "postcss": "^8.5.6",
    "rxjs": "^7.8.2",
    "tailwindcss": "^4.1.18",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.6",
    "@angular/cli": "^20.3.6",
    "@angular/compiler-cli": "^20.3.0",
    "@tailwindcss/aspect-ratio": "^0.4.2",
    "@tailwindcss/forms": "^0.5.7",
    "@tailwindcss/typography": "^0.5.13",
    "@types/crypto-js": "^4",
    "@types/express": "^5.0.1",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.17.19",
    "autoprefixer": "^10.4.20",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "less": "^4.2.0",
    "postcss-import": "^16.1.1",
    "typescript": "~5.9.2"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
